import * as React from "react";

export const Home = () => (
    <div>
        Nothing much here.
    </div>
);
